import Screen from 'quasar/src/plugins/Screen.js';;

// Вычисляет размер для кнопки
export default function(width: number): { width?: string } {
	if (Screen.name !== 'xs') {
		return {};
	}

	// Плата за отступы, 2 процентов хватает на любой ряд кнопок
	const marginFee = 2;

	return { width: 100 / width - marginFee + '%' };
}
